export enum AffiliateState {
  Active = 1,
  Inactive = 2
};